import React from "react";
import { Container } from "react-bootstrap";

const PortfolioHero = () => {
  return (
    <Container fluid className="hero-container">
      <h1 className="hero-title-portfolio">Portfolio</h1>
      <p className="hero-text">
        Experience excellence with our trusted solutions, driving innovation, efficiency, and growth for your business success like never before.
      </p>
      <style>{`
        .hero-container {
          text-align: center;
          padding: 50px 20px;
        }
        .hero-title {
          font-weight: bold;
          font-size: 2.5rem;
        }
        .hero-text {
          color: gray;
          font-size: 1.2rem;
          max-width: 700px;
          margin: 0 auto;
        }
        @media (max-width: 768px) {
          .hero-title {
            font-size: 20px;
          }
          .hero-text {
            font-size: 14px;
          }
        }
      `}</style>
    </Container>
  );
};

export default PortfolioHero;
